module.exports = __webpack_public_path__ + "static/media/South-western_iberian_bronze_icon.3f28a4d0.png";